import { ICardInfoData } from "../interfaces/card-info.interface";

export const CARD_ICON_DIR = 'images/shared/cards'
export const NUMBER_ICON_DIR = 'images/shared/steps';

export const BusinessMobileConsulting: ICardInfoData[] = [{
    icon: `${CARD_ICON_DIR}/rocket.png`,
    title: "reach customers where they are",
    text: "Most digital time is spent in apps, not browsers. A branded mobile presence puts your message directly on your customer's home screen — past the inbox, past the ad feed."
},
{
    icon: `${CARD_ICON_DIR}/plant.png`,
    title: "deepen the relationship",
    text: "Push notifications, account-aware experiences, and in-app messaging keep customers engaged between purchases — turning one-time buyers into repeat ones."
},
{
    icon: `${CARD_ICON_DIR}/screw.png`,
    title: "cut operational drag",
    text: "Self-service flows, automated workflows, and real-time field data replace phone calls, paper forms, and back-office friction — measurable lift in support load and team capacity."
},
{
    icon: `${CARD_ICON_DIR}/bag.png`,
    title: "open new revenue lines",
    text: "Subscriptions, in-app purchases, marketplace fees, premium tiers — mobile unlocks monetization models that don't work on a desktop site."
}, {
    icon: `${CARD_ICON_DIR}/cheese.png`,
    title: "see what's actually happening",
    text: "Mobile analytics surface user behavior at the feature level: which screens convert, where users drop off, what drives retention. You stop guessing and start shipping what works."
}]

export const BusinessMobileConsultingNumberedCardInfo: ICardInfoData[] = [{
    icon: `${NUMBER_ICON_DIR}/01.png`,
    title: "discover · 1 to 2 weeks",
    text: "We map your business model, your users, and where mobile adds real leverage. You leave with a prioritized feature list, a tech recommendation, and a realistic budget — not a sales pitch."
},
{
    icon: `${NUMBER_ICON_DIR}/02.png`,
    title: "build · 8 to 16 weeks",
    text: "Design, develop, integrate. Weekly demos, working software early, iOS and Android in parallel. You steer the product before it's locked in."
},
{
    icon: `${NUMBER_ICON_DIR}/03.png`,
    title: "launch + grow · ongoing",
    text: "App Store launch, growth experiments, performance monitoring, and version-over-version improvements. Shipping is the start, not the end."
}]
